module.exports = __webpack_public_path__ + "media/images/iconInfo__inactive-2cf005c3775376155280ed3f513da6c7.png";